export type LogType = {
  date: string;
  id: string;
  meta: null | string;
  score: null;
  service: string;
  text: string;
  worker: string;
  workerParent: string | null;
  metadata?: string;
};

export const DIRECTIONS = {
  before: "before",
  after: "after",
  middle: "middle",
};

export type DirectionType = (typeof DIRECTIONS)[keyof typeof DIRECTIONS];

export type GetLogsRequestType = {
  appId: string;
  text: string | null;
  dateFrom: string;
  dateTo: string;
  direction: DirectionType;
  worker: string[];
  countQuery?: boolean;
};

export type GenerateExportsRequestType = {
  appId: string;
  text: string | null;
  dateFrom: string;
  dateTo: string;
  workers: string[];
};

export type SendFormRequestType = {
  email: string;
  teamId: string;
  message: string;
  estimation: number;
};

export type GetHistoryRequestType = {
  appId: string;
};

export type CreateAlertRequestType = {
  appId: string;
  text: string;
  checkType: number; // nwm co to, ale ma byc 1
  channels: [
    {
      channelType: number; // 1 - email
      params: {
        emails?: string[];
        webhookUrl?: string;
      };
    },
  ];
};

export type S3BackupConfigStatus = "active" | "paused" | "error";

export type S3BackupConfig = {
  id: string;
  teamId: string;
  name: string;
  status: S3BackupConfigStatus;
  errorReason: string | null;
  s3Endpoint: string;
  s3Bucket: string;
  s3Region: string;
  s3AccessKey: string;
  appIds: string[] | null;
  expirationDays: number;
  lastUploadAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export type S3BackupSegment = {
  id: string;
  configId: string | null;
  workerId: string;
  appId: string | null;
  s3Key: string;
  fileName: string;
  startDate: string;
  endDate: string;
  fileSizeBytes: number;
  documentCount: number;
  status: string;
  createdAt: string;
};

export type CreateS3BackupConfigRequest = {
  name: string;
  s3Endpoint: string;
  s3Bucket: string;
  s3Region?: string;
  s3AccessKey: string;
  s3SecretKey: string;
  appIds: string[];
  expirationDays?: number;
};

export type UpdateS3BackupConfigRequest = Partial<CreateS3BackupConfigRequest>;
